import React from 'react';
import { Link } from 'react-router-dom';
import { CATEGORIES } from '@/data/mockData';
import { Button } from '@/components/ui/button';
import { useCountry } from '@/contexts/CountryContext';

export const PopularCategories = () => {
  const { country } = useCountry();
  return (
    <section className="py-16 bg-white" data-testid="popular-categories">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-3xl font-bold text-gray-900">Popular Categories</h2>
            <p className="text-gray-600 mt-2">Explore what {country.name} has to offer</p>
          </div>
          <Button variant="outline" size="sm" asChild>
            <Link to="/categories">View All</Link>
          </Button>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {CATEGORIES.map(c => (
            <Link key={c.slug} to={`/search?category=${c.slug}`} className="group" data-testid={`category-card-${c.slug}`}>
              <div className="bg-gray-50 rounded-xl p-6 text-center transition-all duration-300 hover:shadow-lg hover:-translate-y-1 hover:bg-white border border-gray-200 h-full">
                <div className="text-4xl mb-3">{c.emoji}</div>
                <h3 className="font-heading font-semibold text-gray-900 group-hover:text-[#00AA6C] transition-colors">{c.name}</h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
